import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';

export interface Event {
  eventId: string;
  eventName: string;
  eventTime: string;
  sportId: string;
  oddsData: {
    inPlay: boolean;
    preBet: boolean;
    runners: any[];
    status: string;
  };
}

@Injectable({ providedIn: 'root' })
export class EventService {
  private apiUrl = environment.apiUrl + '/api/exchange/market/matchodds/allEventsList';

  constructor(private http: HttpClient) {}

  getAllEvents(): Observable<Event[]> {
    return this.http.get<Event[]>(this.apiUrl);
  }

  getInPlayEvents(): Observable<Event[]> {
    return this.getAllEvents().pipe(
      map(events => (events || []).filter(e => e.oddsData?.inPlay === true))
    );
  }
}